module.exports = __webpack_public_path__ + "img/product_70.d6ac763.webp";